import {
  GET_LIST_THUDELETE,
  GET_LIST_THUDELETE_SUCCESS,
  GET_LIST_THUDELETE_FAILURE,
} from "../../actions/DanhSachThuDelete/actionTypes";

const initialState = {
  list: [],
  TongTien: 0,
  SoHopDong: 0,
  getListThuDeleteLoading: false,
};
const getListThuDelete = (state, action) => ({
  ...state,
  getListThuDeleteLoading: true,
});

const getListThuDeleteSuccess = (state, action) => {
  return {
    ...state,
    list: action.payload.list,
    SoHopDong: action.payload.SoHopDong,
    TongTien: action.payload.TongTien,
    getListThuDeleteLoading: false,
  };
};

const getListThuDeleteFailed = (state, action) => ({
  ...state,
  getListThuDeleteLoading: false,
  list: [],
});
export const listThuDeleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_THUDELETE:
      return getListThuDelete(state, action);
    case GET_LIST_THUDELETE_SUCCESS:
      return getListThuDeleteSuccess(state, action);
    case GET_LIST_THUDELETE_FAILURE:
      return getListThuDeleteFailed(state, action);
    default:
      return state;
  }
};

export default listThuDeleteReducer;
